<template>
  <div class="err">
    <el-dialog :visible.sync="dialogTableVisible" :show-close="false">
      <div class="err" @click="$router.push({ path: '/' })">
        <div class="img_box">
          <img src="@/assets/error404.svg" alt="" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "error",
  data() {
    return {
      dialogTableVisible: true,
    };
  },
  mounted() {
    // 如果页面404 则在3秒钟之后跳转回首页
    setTimeout(function () {
      this.$router.push({ path: "/" });
    }, 3000);
  },
};
</script>

<style lang="less" scoped>
.err {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .img_box {
    margin: auto;
    width: 56.25rem;
    height: 56.25rem;
    img {
      width: 100%;
    }
  }

  /deep/ .el-dialog {
    width: 100%;
    height: 100%;
    margin: 0 !important;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
